// extracted by mini-css-extract-plugin
export default {"head":"PermissionList_head__9Q1Im","headMain":"PermissionList_headMain__psE0s","id":"PermissionList_id__H8CTG"};